import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import * as moment from 'moment';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import play from '../../assets/icons/play-54-4b7fa8b71484507993b8958a4124dcce.png';


class FeaturedItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isGalleryOpened: false,
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    const { featuredItem, typeOfListing } = this.props;
    const image = featuredItem.mainImage ? featuredItem.mainImage : featuredItem.image;
    const title = featuredItem.title ? featuredItem.title : featuredItem.name;

    return (
      <React.Fragment>
        { featuredItem.title &&
        <div className="content-item-container">
          <div className="bg-white thumbnail">
            <LazyLoad offset={10}>
              <a className="video" href={`/${featuredItem.slug}`}>

                <img alt="6 thumbnail image" className="img-responsive video-thumbnail" src={image} style={{ opacity: 1 }} />

                <img alt="Play 54" className="play-icon" src={play} />

              </a>
            </LazyLoad>
            <div className="caption">
              <a href={`/${featuredItem.slug}`}>{title}</a>
              <small className="text-muted">{moment(featuredItem.date).format('LLLL')}</small>
            </div>
          </div>
        </div>
        }
        { featuredItem.name &&
        <div className="content-item-container">
          <a className="content-item gallery-item" href="#" title={title} onClick={() => this.setState({ isOpen: true })}>
            <div className="content-item-thumbnail">
              <img alt="Xlthumb placeholder" src={image} style={{ opacity: 1 }} />
            </div>
            <div className="content-item-caption">
              <div className="content-item-title">
                {title}
              </div>
            </div>
          </a>
          {isOpen && (
            <Lightbox
              mainSrc={featuredItem.images[photoIndex]}
              nextSrc={featuredItem.images[(photoIndex + 1) % featuredItem.images.length]}
              prevSrc={featuredItem.images[(photoIndex + featuredItem.images.length - 1) % featuredItem.images.length]}
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMoveNextRequest={() =>
                this.setState({ photoIndex: (photoIndex + 1) % featuredItem.images.length })
              }
              onMovePrevRequest={() =>
                this.setState({ photoIndex: (photoIndex + featuredItem.images.length - 1) % featuredItem.images.length })
              }
            />
          )}
        </div>
        }
      </React.Fragment>
    );
  }
}

export default FeaturedItem;
